"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = require("react");
var financeDisclaimerStyles_1 = require("./financeDisclaimerStyles");
var FinanceDisclaimer = function (_a) {
    var disclaimers = _a.disclaimers;
    var styles = financeDisclaimerStyles_1.default();
    return (<core_1.Box className={styles.wrapper} data-test="summary:financeBreakdownBlock:disclaimer">
      {disclaimers.map(function (row, index) {
        var value = row.value;
        return (<core_1.Typography key={index} variant="body2" className={styles.text} dangerouslySetInnerHTML={{ __html: value }}/>);
    })}
    </core_1.Box>);
};
exports.default = FinanceDisclaimer;
